import React from 'react';

export default function PublicSchoolModalContent() {
  return (
    <>
      <p>
        An institution whose educational programs are operated by a state or
        other government entity and are primarily supported by public funds.
      </p>
    </>
  );
}
